import React, { PropTypes } from 'react';
import StarRating from 'common/components/star_rating';
import moment from 'moment';
import { v4 } from 'node-uuid';
import classnames from 'classnames';

const EmptyTestimonials = ({ username }) => (
  <div className="profile-testimonials">
    <h2 className="section-title">Testimonials</h2>
    <div className="empty-state">
      <div className="empty-state-content">
        <h3 className="text-center">{username} doesn&apos;t have any testimonials.</h3>
      </div>
    </div>
  </div>
);

const Testimonial = ({
  score, comment, created_at, author: { username }
}) => {
  const testimonialDate = moment(created_at).calendar();

  return (<div className="testimonial row">
    <div className="column small-8">
      <StarRating readonly={true} initialRate={score || 0}/>
    </div>
    <div className="column small-8 testimonial-date">{ testimonialDate }</div>
    <div className="column small-16 testimonial-content">
      { comment && <span>{ comment } - </span> }
      <span>{ username }</span>
    </div>
  </div>);
};

const Testimonials = ({ username, testimonials, toggleTestimonials, showAllTestimonials }) => {
  if (!testimonials || !testimonials.length) {
    return <EmptyTestimonials username={username} />;
  }

  const testimonialClasses = classnames('profile-testimonials row', {
    'show-all': showAllTestimonials
  });

  return (<div className={testimonialClasses}>
    <h2 className="section-title">Testimonials</h2>
    { testimonials.map(testimonial => (
      <Testimonial key={v4()} {...testimonial} />
    )) }
    { testimonials.length > 1 && <div className="small-16 toggle-button-container">
      <a onClick={toggleTestimonials} className="btn btn-secondary">More Testimonials</a>
    </div> }
  </div>);
};

const TestimonialShape = {
  comment: PropTypes.string,
  created_at: PropTypes.string,
  author: PropTypes.shape({
    id: PropTypes.number,
    username: PropTypes.string,
  }),
  score: PropTypes.number,
};

EmptyTestimonials.propTypes = {
  username: PropTypes.string,
};

Testimonial.propTypes = TestimonialShape;

Testimonials.propTypes = {
  username: PropTypes.string,
  testimonials: PropTypes.arrayOf(PropTypes.shape(TestimonialShape)),
  toggleTestimonials: PropTypes.func,
  showAllTestimonials: PropTypes.bool,
};

export { Testimonial, EmptyTestimonials };
export default Testimonials;



// WEBPACK FOOTER //
// ./profile/components/testimonials.jsx